import * as React from 'react';

export default function StarIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 13" fill="none" {...props}>
      <path
        d="M6.116.676a1 1 0 011.768 0L9.216 3.2a1 1 0 00.714.518l2.81.487a1 1 0 01.547 1.682L11.3 7.933a1 1 0 00-.273.84l.406 2.823a1 1 0 01-1.43 1.04l-2.56-1.259a1 1 0 00-.883 0l-2.56 1.259a1 1 0 01-1.431-1.04l.406-2.824a1 1 0 00-.273-.84L.713 5.888a1 1 0 01.546-1.682l2.811-.487a1 1 0 00.714-.518L6.116.676z"
        fill="currentColor"
      />
    </svg>
  );
}
